var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user/outline/users 01"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 293",
    cx: 10.5,
    cy: 18,
    rx: 7,
    ry: 3.5,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 294",
    cx: 10.5,
    cy: 7.5,
    r: 4,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5448 10.7498C15.2228 11.2487 14.8288 11.6968 14.3774 12.0793C14.7319 12.1904 15.109 12.2502 15.5001 12.2502C17.5712 12.2502 19.2501 10.5713 19.2501 8.50024C19.2501 6.54446 17.7529 4.93838 15.8421 4.76562C16.1083 5.28459 16.3011 5.84742 16.4068 6.44039C17.1979 6.78911 17.7501 7.58019 17.7501 8.50024C17.7501 9.72794 16.7668 10.726 15.5448 10.7498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4997 18.0565C19.4896 18.6707 19.3148 19.2608 19.0009 19.8111C19.3693 19.7097 19.7144 19.5923 20.0312 19.4603C20.6284 19.2115 21.1606 18.8961 21.555 18.5076C21.952 18.1165 22.2501 17.6066 22.2501 17.0002C22.2501 16.3938 21.952 15.8839 21.555 15.4928C21.1606 15.1043 20.6284 14.7889 20.0312 14.5401C19.0086 14.114 17.6907 13.8396 16.2495 13.7686C17.2517 14.2776 18.0702 14.9172 18.6351 15.6445C18.9329 15.7277 19.2072 15.8218 19.4543 15.9247C19.943 16.1283 20.2894 16.3517 20.5023 16.5614C20.7125 16.7685 20.7501 16.9163 20.7501 17.0002C20.7501 17.0841 20.7125 17.2319 20.5023 17.439C20.2961 17.6421 19.9645 17.8581 19.4997 18.0565Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.584e55d2a2708fab90b006feaee98a9e.svg";
export { ForwardRef as ReactComponent };